import { Component, ElementRef, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { ListContent, Product, Restaurant } from '../core/models';
import { ContentService } from '../core/services/content.service';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { finalize } from 'rxjs';
import Dinero from 'dinero.js';
import { Meta } from '@angular/platform-browser';
import { FooterComponent } from './../footer/footer.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseMarketRowComponent } from './../market/base-market-row/base-market-row.component';
import { RouterLink } from '@angular/router';
import { NavbarComponent } from './../navbar/navbar.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-main',
    standalone: true,
    imports: [FooterComponent, BaseMarketRowComponent, RouterLink, TranslocoPipe, NavbarComponent],
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.css'],
})

export class MainComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    isMobile: boolean = false;
    featuredList: ListContent;
    resolvingList: boolean = true;

    testingProduct = new Product().deserialize({ id: '1', restaurant: new Restaurant(), price: Dinero({ amount: 100, currency: 'CAD' }) })
    testing;

    constructor(
        private contentService: ContentService,
        public translate: TranslocoService,
        public modalService: NgbModal,
        private metaService: Meta
    ) { }

    ngOnInit(): void {
        this.isMobile = window.innerWidth <= 991;
        window.onresize = () => this.isMobile = window.innerWidth <= 768;

        this.contentService.fetchList('featured')
            .pipe(
                finalize(() => this.resolvingList = false),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(list => this.featuredList = list);

        this.testing = [{ title: 'testing', items: [this.testingProduct] }]

        this.metaService.addTag({ name: 'robots', content: 'noindex, follow' });

    }
}
